<template>
  <div class="propval d-flex" v-if="propVal">
      <div>
        <template v-if="name">
          {{ name }}
        </template>
        <template v-else>
          {{ propTitle }}
        </template>
      </div>
      <div>
        {{ propVal }}
      </div>
  </div>
</template>

<script>
export default
{
  props:["id","name","item"],
  data: function()
  {
    return {
      propVal : null,
      propTitle: null
    }
  },
  computed:
      {

        searchProps: function()
        {
          let currentVariation = this.item;
          let propId           = this.id;
          let _self            = this;
          if(currentVariation.variationProperties.length > 0)
          {
            for(let i = 0; i < currentVariation.variationProperties.length; i++)
            {
              for(let i2 = 0; i2 < currentVariation.variationProperties[i].properties.length; i2++)
              {
                  if(currentVariation.variationProperties[i].properties[i2].id == propId )
                  {
                    _self.propTitle = currentVariation.variationProperties[i].properties[i2].names.name
                    _self.propVal   = currentVariation.variationProperties[i].properties[i2].values.value
                  }
              }
            }
          }
        },
      }
}
</script>
